import script from "./ImageUpload.vue?vue&type=script&setup=true&lang=ts"
export * from "./ImageUpload.vue?vue&type=script&setup=true&lang=ts"

import "./ImageUpload.vue?vue&type=style&index=0&id=640fb13c&scoped=true&lang=css"

import exportComponent from "/var/www/html/laraccm2021/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-640fb13c"]])

export default __exports__